import { Card, Checkbox, InputNumber } from "antd";
import { useState } from "react";
import BbotButton from "top-component-library/BbotButton";

import { Section, SettingRow } from "../styles";
import { toCents } from "../utils";

// Manual and automatic refill controls. The manual-payment amount is local input state (in
// dollars); the automatic-refill thresholds live on the trove in cents.
const PaymentCard = ({ trove, saving, paying, onUpdateField, onSave, onManualRefill }) => {
  const [manualPaymentDollars, setManualPaymentDollars] = useState(0);

  const handlePayNow = async () => {
    const submitted = await onManualRefill(manualPaymentDollars);
    if (submitted) setManualPaymentDollars(0);
  };

  return (
    <Section>
      <Card title="Make a payment">
        <h4>Manual Refill</h4>
        <SettingRow>
          <span>Pay $</span>
          <InputNumber
            id="tmm-manual-payment"
            min={0}
            step={0.01}
            value={manualPaymentDollars}
            onChange={(value) => setManualPaymentDollars(Number(value) || 0)}
          />
          <span>now (this charges your primary payment method).</span>
          <BbotButton type="primary" disabled={manualPaymentDollars < 0.5} loading={paying} onClick={handlePayNow}>
            Pay Now
          </BbotButton>
        </SettingRow>

        <h4>Automatic Refill</h4>
        {trove.auto_payments && (
          <SettingRow>
            <span>When my balance falls below $</span>
            <InputNumber
              id="tmm-auto-threshold"
              min={0}
              step={0.01}
              value={trove.auto_payment_threshold / 100}
              onChange={(value) => onUpdateField("auto_payment_threshold", toCents(value))}
            />
            <span>, pay $</span>
            <InputNumber
              id="tmm-auto-amount"
              min={0.5}
              step={0.01}
              value={trove.auto_payment_amount / 100}
              onChange={(value) => onUpdateField("auto_payment_amount", toCents(value))}
            />
            <span>(this charges your primary payment method).</span>
          </SettingRow>
        )}
        <SettingRow>
          <Checkbox checked={trove.auto_payments} onChange={(e) => onUpdateField("auto_payments", e.target.checked)}>
            Activate Automatic Refill
          </Checkbox>
        </SettingRow>
        <BbotButton type="primary" loading={saving} onClick={onSave}>
          Save
        </BbotButton>
      </Card>
    </Section>
  );
};

export default PaymentCard;
